export default class CustomError extends Error {
  constructor(message = 'GENERIC', status = '500', code = '400') {
    super(message)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CustomError)
    }
    this.status = status

    this.data = {
      message,
      code,
    }
  }
}
